import { render, staticRenderFns } from "./SparkButton.vue?vue&type=template&id=6db36510&"
import script from "./SparkButton.vue?vue&type=script&lang=js&"
export * from "./SparkButton.vue?vue&type=script&lang=js&"
import style0 from "./SparkButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports